import React from 'react';
import { useDispatch, useSelector } from "react-redux";

import moment from "moment/moment";
import { freeTimeToCome } from "../../constants/freeTimeToCome";
import { stepperInfoActions } from "../../store/slices/stepperInfoSlice";
import { getKyivNow } from "../../utils/kyivTime";
import styles from './FreeTimeToCome.module.scss';

const FreeTimeToCome = ({filteredTime}) => {
    const dispatch = useDispatch();
    const {selectedTime, selectedDate} = useSelector(state => state.stepperInfo);

    const handleChangeRequestTime = (time) => {
        dispatch(stepperInfoActions.setSelectedTime(time));

        if (selectedDate) {
            const combinedDateTime = moment(new Date(selectedDate)).set({
                hour: time?.split(':')[0],
                minute: time?.split(':')[1],
            });

            dispatch(stepperInfoActions.setRequestDateTime(combinedDateTime.toISOString()));
        }
    }
   
    const kyivNow = getKyivNow();
    const isSelectedDateCurrentDate = ((kyivNow.getDate() === new Date(selectedDate).getDate()) && (kyivNow.getMonth() === new Date(selectedDate).getMonth()) && (kyivNow.getFullYear() === new Date(selectedDate).getFullYear()))

    return (
        <div className={styles.freeTimeToCome_wrapper}>
            <p className={styles.freeTimeToCome_wrapper_subtitle}>Виберіть час зручного прибуття клінера <sup>*</sup></p>

            <div className={`${styles.freeTimeToCome_wrapper_freeTimeToCome} ${(isSelectedDateCurrentDate ? filteredTime : freeTimeToCome).length === 0 ? styles.none : ""}`}>
                {(isSelectedDateCurrentDate ? filteredTime : freeTimeToCome).map((item, index) =>
                    <div
                        onClick={() => handleChangeRequestTime(item)}
                        className={`${styles.freeTimeToCome_wrapper_freeTimeToCome_item} 
                            ${(selectedTime === item) ? styles.selected : ''}`}
                        key={index}
                    >{item}</div>)}

            </div>

            {(isSelectedDateCurrentDate ? filteredTime : freeTimeToCome).length === 0 &&
                <p className={styles.freeTimeToCome_wrapper_noTime}>На жаль, на сьогодні вже немає вільних годин</p>}
        </div>
    );
};

export default FreeTimeToCome;
